import { makeStyles } from "@material-ui/styles";
export default makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "flex-start",
    paddingTop: "4rem",
    height: "100%",
  },
  progress: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50%",
  },
  message: {
    marginTop: theme.spacing(2),
  },
}));
